import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const PriorityuppTickets = () => {
  return (
    <SettingsMetaData propertyName={"Priority_Support_Tickets"} viewPropertyName={"Priority"} />
  );
};
export default PriorityuppTickets;